// extracted by mini-css-extract-plugin
export default {"basket":"CartBox_basket__W9YcB","qty":"CartBox_qty__OScfU","cartBox":"CartBox_cartBox__Ods5+"};